import React from 'react'
import { getChargeProvidersDetails } from '../../../views/pages/Encounters/components/Utilities/Helpers'
import { WHITE } from '../../../scss/colorConsts'

export function evaluateProviderCell(charge, incidentProviderList = [], canUseLastVisit) {
  const { renderingName, renderingInitials, incidentName, incidentInitials } =
    getChargeProvidersDetails(charge, incidentProviderList, canUseLastVisit)

  return (
    <span title={renderingName + (incidentName ? ' / ' + incidentName : '')}>
      {incidentName ? (
        <>
          {renderingInitials}/<span style={{ color: WHITE }}>{incidentInitials}</span>
        </>
      ) : (
        renderingName
      )}
    </span>
  )
}

// we refuse to cement how this should work, so consolidate/mirror the different ways we do this
// no practice check? just the provider value
// practice? means we are also checking the biller, and undefined counts
export function hasMedicalCoding({ practice, provider, roles, billerCheck }) {
  // (provider?.medical_coding === true || provider?.medical_coding === undefined)
  if (!practice) {
    return provider?.medical_coding
  }

  const canMedicalCode = practice?.medical_coding && provider?.medical_coding !== false
  if (billerCheck) {
    return canMedicalCode && !roles?.includes('Claimocity App Biller')
  }

  return canMedicalCode
}
